import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, Row, Col, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Translate, translate } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { generateCaptcha } from './password-reset.reducer';
import { IRootState } from 'app/shared/reducers';
import '../password-reset/passwordReset.scss';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { SUCCESS } from 'app/config/constants';

export interface IModalCaptchaProps extends StateProps, DispatchProps, RouteComponentProps<{ key: any }> {}

export interface IModalCaptchaProps {
  showModalCaptcha: boolean;
  invokeCancel: Function;
  invokeAgree: Function;
  dismissAlert: Function;
  errMessage: string;
  isOpenAlert: boolean;
  fullName: string;
  mobile: string;
  email: string;
}

export interface IModalCaptchaInitState {
  captcha: string;
  visible: boolean;
}

class ModalInputCaptcha extends React.Component<IModalCaptchaProps, IModalCaptchaInitState> {
  state: IModalCaptchaInitState = {
    captcha: '',
    visible: false
  };
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    }
  }
  componentWillMount() {
    this.props.generateCaptcha();
  }

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  handleValidSubmit = (event, values) => {
    this.props.invokeAgree(values);
  };

  toggle = () => {
    this.props.invokeCancel();
  };

  sendOtp = type => {};

  onDismiss = () => {
    this.props.dismissAlert();
  };

  render() {
    return (
      <div>
        <Modal isOpen={this.props.showModalCaptcha} toggle={this.toggle} centered>
          {/*<ModalHeader toggle={this.toggle} />*/}
          <Alert color="danger" isOpen={this.props.isOpenAlert} toggle={this.onDismiss}>
            {this.props.errMessage}
          </Alert>
          <ModalBody>
            <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
              <Button onClick={this.toggle} close />
            </div>
            <div className="box-reotp">
              <Row>
                <Col className="justify-content-center">
                  <h2 className="text-center">Chọn phương thức xác thực</h2>
                  <p className="text-center">Chào mừng bạn đến với Nền tảng quản lý định danh và xác thực</p>
                  <p className="text-center">Ngành tài nguyên và môi trường</p>
                  <p className="text-center" style={{ color: 'black' }}>
                    Tài khoản: <span className="font-weight-bold">{this.props.fullName}</span>{' '}
                  </p>
                  <p className="text-center" style={{ marginTop: '10px' }}>
                    Chọn phương thức xác thực
                  </p>
                  <AvForm id="resend-otp-form">
                    <Button
                      style={{
                        width: '414px',
                        height: '50px',
                        margin: '10px auto',
                        background: '#4D9235'
                      }}
                      className="d-flex align-items-center"
                      onClick={() => this.props.invokeAgree('EMAIL')}
                    >
                      <div>
                        <img
                          src={require('app/images/email.png')}
                          style={{ width: '24.37px', marginLeft: '16.41px', marginRight: '10px' }}
                          alt=""
                        />
                        <span className="type-sotp">Xác thực Email: {this.props.email}</span>
                      </div>
                    </Button>
                    <Button
                      style={{
                        width: '414px',
                        height: '50px',
                        margin: '10px auto',
                        background: '#4D9235'
                      }}
                      className="d-flex align-items-center"
                      onClick={() => this.props.invokeAgree('SMS')}
                    >
                      <div>
                        <img
                          src={require('app/images/mobile.png')}
                          style={{ width: '15.17px', marginLeft: '21px', marginRight: '10px' }}
                          alt=""
                        />
                        <span className="type-sotp">Xác thực điện thoại di động: {this.props.mobile}</span>
                      </div>
                    </Button>
                  </AvForm>
                </Col>
              </Row>
            </div>
          </ModalBody>
          {/* <ModalFooter>

          </ModalFooter> */}
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = ({ passwordReset }: IRootState) => ({
  responseCap: passwordReset.responseCaptcha
});

const mapDispatchToProps = { generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalInputCaptcha);
